// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Wy-z","modalContent":"Xy-z","header":"Yy-z","close":"Zy-z"};